import React from 'react';
import { Stack } from '@mui/system';
import { Box, Checkbox } from '@mui/material';
import { Typography, TextField, Grid } from '@mui/material';
import deleteIcon from '../../../Images/delete_red_icon.svg';
import infoIcon from '../../../Images/blue_info.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
	settrainingCenterID,
	showtrainingDetails,
	setdeleteList,
	setfliterDeleteList,
	setcheckedList,
	setflitercheckedList,
} from '../../../redux/features/trainingCenter';
import axios from '../../../globals/common_utilities/axios_old';
import CONSTANTURL from '../../../globals/common_utilities/constanturls';
import { APP_ROUTES, FOMRS } from '../../../globals/constants';
import './ListView.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const ListView = (props) => {
	const [id, setID] = useState('');
	const navigate = useNavigate();
	const [checked, setChecked] = useState(false);
	// const [checkedArray, setCheckedArray] = useState([]);
	const { res, ondeleteClick, multipleSelected } = props;
	let title = res?.studio_name;
	let titlelength = title?.length;
	let slicedTitle = title?.slice(0, 25);
	const dispatch = useDispatch();

	let deleteTC = useSelector(
		(state) => state.trainingCenterDetails?.deleteList
	);

	let selectedTC = useSelector(
		(state) => state.trainingCenterDetails?.checkedList
	);

	useEffect(() => {
		console.log('titlelength', titlelength);
		setChecked(false);
	}, [res]);

	const checkTraining = (e) => {
		e.stopPropagation();
	};

	const editTraining = (e) => {
		e.stopPropagation();
	};

	const deleteTraining = (e, id) => {
		e.stopPropagation();
		ondeleteClick(id);
	};

	const tcChecked = (e) => {
		setChecked(e.target.checked);
		// console.log('deleteTC', deleteTC);
		// console.log('res', res);
	};

	const selected = () => {
		dispatch(setdeleteList(res.id));
		dispatch(setcheckedList(res));
	};

	let filterdArray = (id) => {
		let filteredList = deleteTC.filter(function (item) {
			console.log('item', item);

			return item !== id;
		});
		dispatch(setfliterDeleteList(filteredList));
		console.log('filteredList', filteredList);
	};

	let filterExportObject = (id) => {
		let filteredcheckedList = selectedTC.filter(function (item) {
			// console.log('item', item.id);
			// console.log('id', id);
			return item.id !== id;
		});
		dispatch(setflitercheckedList(filteredcheckedList));
		// console.log('filteredcheckedList', filteredcheckedList);
	};

	const unselected = (TcId) => {
		// console.log('TcId', TcId.id);
		filterdArray(TcId);
		filterExportObject(TcId);
	};

	useEffect(() => {
		checked ? selected() : unselected(res.id);
	}, [checked]);

	return (
		<>
			<Box
				sx={{ bgcolor: '#0C0D16', m: '1% 1% 0% 1%' }}
				id="trainingCenter"
				className="list"
			>
				{res ? (
					<Stack
						direction="row"
						sx={{
							pt: '0.2%',
							// flexDirection: { xs: 'column', sm: 'row' }
						}}
						onClick={() => {
							dispatch(settrainingCenterID(res.id));
							dispatch(showtrainingDetails(true));
							// console.log('name', res.id);
						}}
					>
						{/* <Grid item xs={0.8} sm={0.8} md={0.8}>
						<Stack className="checkboxTC">
							<Checkbox />
						</Stack>
					</Grid> */}
						<Grid container>
							<Grid item xs={9} sm={10} md={11}>
								<Stack spacing={{ sx: 1, sm: 2 }} direction="row">
									<Stack className="checkboxTC mt-left">
										<Checkbox
											checked={checked}
											onChange={(e) => {
												tcChecked(e);
											}}
											onClick={(e) => {
												checkTraining(e);
											}}
										/>
									</Stack>
									<Stack className="fs-3 mt-Row " width="25%">
										{titlelength > 25 ? `${slicedTitle}...` : res?.studio_name}
									</Stack>
									<Stack
										className="borderRight"
										sx={{
											borderRight: '1px solid #338fee',
											height: '30px',
										}}
									></Stack>
									<Stack className="fs-4 mt-Row " width="15%">
										{res?.created_at}
									</Stack>
									<Stack
										className="borderRight"
										sx={{ borderRight: '1px solid #338fee', height: '30px' }}
									></Stack>
									<Stack className="country" width="25%">
										<span className=" fs-5 locationText">
											{res?.location?.address}
										</span>
									</Stack>
								</Stack>
								<Stack
									sx={{
										borderTop: '1px solid #338fee',
										// mt: '0.6%',
										width: '95%',
										marginLeft: '2.5%',
									}}
								></Stack>
								<Stack
									direction="row"
									marginTop={{ xs: '2%', sm: '0%' }}
									sx={{
										flexDirection: { xs: 'column', sm: 'column', md: 'row' },
									}}
									justifyContent="space-evenly"
									margin="0.2%"
								>
									<Stack
										sx={{ padding: '0.8%' }}
										paddingLeft={{ xs: '5%', md: '0%' }}
										direction="row"
									>
										<Stack spacing="1%">
											<span className="fs-4">
												No. of Scheduled Training :{' '}
												<span className="fs-3">{res.training_count}</span>
											</span>
										</Stack>
									</Stack>
									<Stack sx={{ borderRight: '1px solid #338fee' }}></Stack>
									<Stack
										sx={{ paddingTop: '0.5%' }}
										paddingLeft={{ xs: '5%', md: '0%' }}
										direction="row"
									>
										<span className="fs-4">
											No. of Student Attended :{' '}
											<span className="fs-3">{res.student_count}</span>
										</span>
									</Stack>
									<Stack sx={{ borderRight: '1px solid #338fee' }}></Stack>
									<Stack
										sx={{ paddingTop: '0.5%' }}
										paddingLeft={{ xs: '5%', md: '0%' }}
										direction="row"
									>
										<span className="fs-4">
											No. of training Days :{' '}
											<span className="fs-3"> {res.training_days}</span>
										</span>
									</Stack>
								</Stack>
								{/* </Stack> */}
							</Grid>
							<Grid item xs={3} sm={2} md={1}>
								<Box
									sx={{
										width: '80%',
										height: '90%',
										background: 'var(--subBoxBG)',
										borderRadius: 1.5,
										marginLeft: { xs: '5%', md: '0%' },
										marginTop: '4%',
									}}
								>
									<Stack direction="column" spacing={'10px'}>
										<Stack
											direction="row"
											sx={{ justifyContent: 'center', p: '5%' }}
										>
											<span className="fs-4">Action</span>
										</Stack>
										<Stack
											direction={{ xs: 'column', md: 'row' }}
											spacing={{ xs: '10px', md: 2 }}
											sx={{
												justifyContent: 'center',
												paddingLeft: { xs: '36%', md: '0%' },
											}}
										>
											<Stack>
												<Stack
													spacing={1}
													sx={{
														width: 20,
														height: 16,
														p: '2%',
														cursor: 'pointer',
													}}
												>
													<img
														src={infoIcon}
														alt=""
														onClick={(e) => {
															editTraining(e);
															navigate(APP_ROUTES.ADD_TRAINING_CENTRE, {
																state: {
																	type: FOMRS.VIEW,
																	id: res.id,
																},
															});
														}}
													/>
												</Stack>
											</Stack>
											<Stack>
												<Stack
													spacing={1}
													sx={{
														width: 15,
														height: 16,
														ml: '2px',
														cursor: 'pointer',
													}}
												>
													<img
														src={deleteIcon}
														alt=""
														onClick={(e) => {
															deleteTraining(e, res.id);
														}}
													/>
												</Stack>
											</Stack>
										</Stack>
									</Stack>
								</Box>
							</Grid>
						</Grid>
					</Stack>
				) : (
					<Stack>No Record Found</Stack>
				)}
			</Box>
		</>
	);
};

export default ListView;
